import { useState } from 'react';
import { useLogout } from '../../../lib/use-logout';
import { useGenericBi } from '../../../lib/use-generic-bi';
import { SETTINGS_PAGE } from './settings-shared';

export interface LogoutConfirm {
  visible: boolean;
  loggingOut: boolean;
  showConfirm: () => void;
  close: () => void;
  confirm: () => void;
}

// Logout with an in-app confirm — a centered DS Modal on desktop, a bottom sheet on mobile, each
// surface rendering its own view off this state (the same split delete-account uses). Replaces the
// browser's window.confirm. BI on the row click (showConfirm) and on the modal accept/dismiss.
export function useConfirmLogout(): LogoutConfirm {
  const { loggingOut, logout } = useLogout();
  const { logPageClickBi, logModalActionBi } = useGenericBi();
  const [visible, setVisible] = useState(false);

  const showConfirm = () => {
    if (loggingOut) return;
    logPageClickBi({ ...SETTINGS_PAGE, button_name: 'logout' });
    setVisible(true);
  };

  const close = () => {
    logModalActionBi({ page_name: 'settings_page', modal_name: 'logout', action: 'cancel' });
    setVisible(false);
  };

  const confirm = () => {
    logModalActionBi({ page_name: 'settings_page', modal_name: 'logout', action: 'confirm' });
    logout();
  };

  return { visible, loggingOut, showConfirm, close, confirm };
}
